import React, { useEffect, useState } from "react";
import api from "api";
import { useNavigate } from "react-router-dom";
import { FiAlertCircle, FiChevronRight } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
export default function HasPendingOrders({ className }) {
  const user = useSelector((state) => state.user);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(user?.pendingOrders || 0)
  const navigate = useNavigate();
  useEffect(() => {
    setPendingOrdersCount(user?.pendingOrders || 0);
  }, [user?.pendingOrders]);
  useEffect(() => {
    setPendingOrdersCount(user?.pendingOrders || 0);
  }, []);
  if (!user?.pendingOrders || user.pendingOrders == 0) {
    return null;
  }
  return (
    <div
      className={`${className} text-primary text-center d-flex align-items-center justify-content-center gap-2`}
      style={{ cursor: "pointer" }}
      onClick={() => navigate("/customer/account/orders?status=pending")}
    >
      <FiAlertCircle size={18} />
      <span>
        Vous avez {pendingOrdersCount} facture{pendingOrdersCount > 1 ? "s" : ""} en attente de règlement
      </span>
      <FiChevronRight size={18} />
    </div>
  );
}